import React from 'react';
import mountReactApp from 'mount-react-app';
import {routes, reducers} from 'onboarding';

function renderApp() {
  mountReactApp({
    routes,
    reducers,
  });
}

renderApp();

if (module.hot) {
  module.hot.accept('onboarding', () => renderApp());
}
